import { defineComponent } from "vue";
import moment from "moment";
import { Container } from "aurelia-dependency-injection";
import { mapActions, mapState } from "pinia";

import eventBus from "../../../../../utilities/eventBus";
import { useApp } from "../../../../App/useApp";
import { useConversationStore } from "../../../store/useConversationStore";
import { useMessagesStore } from "../../../store/useMessagesStore";
import { MessageService } from "../../../../../services/message-service";
import type { IMessageItem } from "../../../../../resources-vue/vue-interfaces/messaging-service/i-message";
import { formatDate } from "../../../../../common/vue-helpers/modifiers/value-modifier";
import { formatDateToLocalBasedOnDayMode } from "../../../../../common/vue-helpers/modifiers/format-message";
import { ConversationTypeEnum } from "../../../../../enums/enums";
import ErrorMessageHandler from "../../../../../resources-vue/vue-custom-elements/ErrorMessageHandler/ErrorMessageHandler.vue";
import UserMessage from "../UserMessage/UserMessage.vue";
import OthersMessage from "../OthersMessage/OthersMessage.vue";
export default defineComponent({
    components: {
        ErrorMessageHandler,
        UserMessage,
        OthersMessage
    },

    data() {
        return {
            pageSize: 50,
            loadingCount: 2,
            messages: [] as IMessageItem[],
            messagesWrapper: null as HTMLElement,
            unReadMessagesBanner: null as HTMLElement,
            messageReferences: [] as HTMLElement[],
            _messageService: null,
            userOs: "",
            initialChatLoad: true as boolean,
            showMessageLoader: false as boolean,
            isError: false as boolean,
            formatDate,
            formatDateToLocalBasedOnDayMode
        };
    },

    watch: {
        "activeConversation.id"(newValue: string) {
            if (newValue !== null) {
                this.initialChatLoad = true;
            }
        },

        getConversationMessages: {
            handler(newMsgs) {
                if (newMsgs?.length > 0) {
                    this.handleMessageScrollRendering();
                }
            },
            deep: true
        }
    },

    created() {
        this._messageService = Container.instance.get(MessageService);
        this.userOs = window.sessionStorage.getItem("userOs");
        eventBus.on("scrollToBottom", () => {
            this.scrollToBottom();
        });
    },

    async mounted() {
        await this.render();

        this.handleScrolling();
    },

    computed: {
        ...mapState(useConversationStore, { activeConversation: "getActiveConversation" }),
        ...mapState(useMessagesStore, ["getConversationMessages", "getAreConvMsgsLoading"]),
        ...mapState(useApp, ["loggedInUserDetails"]),

        unReadMessages(): IMessageItem[] {
            return this.getConversationMessages.filter((message) => !message.isRead);
        },
        readMessages(): IMessageItem[] {
            return this.getConversationMessages.filter((message) => message.isRead || message.isFromSelf);
        },

        lastSelfMessageIndex(): number {
            return this.readMessages.reduce(
                (lastIndex, message, index) => (message.isFromSelf ? index : lastIndex),
                -1
            );
        },
        isGroupConversation(): boolean {
            return this.activeConversation.conversationType === ConversationTypeEnum.GroupConversation;
        }
    },

    methods: {
        ...mapActions(useMessagesStore, ["fetchOlderMessages"]),

        handleMessageScrollRendering() {
            const scrollableDiv = this.$refs.messagesWrapper as HTMLElement;
            if (this.initialChatLoad) {
                // scroll positioned at bottom when user opens any chat
                this.$nextTick(() => {
                    scrollableDiv.scrollTop = scrollableDiv.scrollHeight;
                    this.initialChatLoad = false;
                });
                return;
            }
            if (scrollableDiv.scrollTop === 0) {
                const oldScrollHeight = scrollableDiv.scrollHeight;
                this.$nextTick(() => {
                    const newScrollHeight = scrollableDiv.scrollHeight;
                    scrollableDiv.scrollTop = newScrollHeight - oldScrollHeight;
                });
            }
        },

        async render() {
            if (this.unReadMessages.length > 0) {
                if (this.$refs.unReadMessagesBanner as HTMLElement) {
                    (this.$refs.unReadMessagesBanner as HTMLElement).scrollIntoView();
                }
            } else {
                this.scrollToBottom();
            }
        },

        scrollToBottom() {
            // The delay is set for rendering the messages in the UI
            // Attempts and info:
            // Aurelia does not have any life cycle hook to know when a view updated
            // ref's don't update in repeat.for. Ref's binding is one-time
            // scroll bindings aurelia have on an element does not have scrollHeight
            setTimeout(() => {
                if (this.$refs.messagesWrapper) {
                    this.messagesWrapper = this.$refs.messagesWrapper as HTMLElement;
                    this.messagesWrapper.scrollTop = (this.$refs.messagesWrapper as HTMLElement).scrollHeight;
                }
            }, 300);
        },

        handleScrolling() {
            let scrollTimer: NodeJS.Timeout = null;
            let $scrollableElement: JQuery<Element> = $(this.$refs.messagesWrapper as HTMLElement);
            $scrollableElement.off("scroll").on("scroll", (e: any) => {
                if (scrollTimer) {
                    clearTimeout(scrollTimer); // clear any previous pending timer
                }
                scrollTimer = setTimeout(async () => {
                    let st: number = $scrollableElement.scrollTop();
                    console.log("SCROLL TOP Null => 370");
                    if (st === 0 && !this.initialChatLoad && this.activeConversation?.id) {
                        console.log("SCROLL TOP 0 => 371");
                        this.showMessageLoader = true;
                        await this.fetchOlderMessages(this.activeConversation.id);
                        this.showMessageLoader = false;
                        this.handleMessageScrollRendering();
                    }
                }, 100); // set new timer
            });
        },

        showDateBanner(index: number) {
            let readMessages = this.readMessages;
            if (index === 0) {
                return true;
            } else if (readMessages.length > 1) {
                let dateFormat = "MM/DD/YYYY";
                let createdOn = moment.utc(readMessages[index].createdOn).local().format(dateFormat);
                let prevCreatedOn = moment
                    .utc(readMessages[index - 1].createdOn)
                    .local()
                    .format(dateFormat);

                return createdOn !== prevCreatedOn;
            } else {
                return false;
            }
        }

        // Below code will be remove in next Tech debt ticket

        // async reset() {
        //     // if (this.isError) {
        //     //     this.$emit("update:isError", false);
        //     // }
        //     this.pageSize = 50;
        //     await this.render();
        // },

        // async retryMessage(message: IMessageItem) {
        // const user = await this._userManager.getUser();
        // let messageQuery: ISendMessageQuery = {
        //     message: message.text ? message.text : "",
        //     isImportant: message.isImportant,
        //     assets: [],
        //     senderDisplayFirstname: this.loggedInUserDetails.firstName,
        //     senderDisplayLastname: this.loggedInUserDetails.lastName
        // };
        // let createdDateTime = new Date();
        // this.updateErrorMessageAsLoading(message);
        // let assetDetails: IAssetDetails[] = [];
        // let isError: boolean = false;
        // try {
        //     let files = message.assets.map((asset) => asset.file);
        //     if (!!files?.length) {
        //         assetDetails = await this._messageService.uploadMessageFiles(files as unknown as File[]);
        //     }
        // } catch (e) {
        //     console.error(e);
        //     isError = true;
        // }
        // if (isError) {
        //     this.markMessageError(message.createdOn, MessageErrorEnum.FileUploadError);
        // } else {
        //     try {
        //         messageQuery.assets = assetDetails;
        //         let messagesResult = await this._messageService.sendMessage(
        //             this.activeConversation.id,
        //             messageQuery
        //         );
        //         this.updateSentMessage(messagesResult, message.createdOn, createdDateTime);
        //         const senderFullName = `${this.loggedInUserDetails.firstName} ${this.loggedInUserDetails.lastName}`;
        //         const notification = {
        //             senderId: this.loggedInUserDetails.loginId,
        //             conversationId: this.activeConversation.id,
        //             messageId: messagesResult.id,
        //             createdAt: new Date().toISOString(),
        //             messageBody: message.text,
        //             messageAssets: [] as string[],
        //             senderName: senderFullName,
        //             clicked: false,
        //             placeholders: message.placeHoldersList
        //         };

        //         // eventBus.emit(NotificationsHubEvents.LoadConversationList, {
        //         //     notification: notification,
        //         //     moveToTop: true
        //         // });
        //         eventBus.emit("retrySuccessful", true);
        //         if (message.assets.length > 0) {
        //             await this.reset();
        //         }
        //     } catch (e) {
        //         console.error(e);
        //         this.markMessageError(message.createdOn, MessageErrorEnum.MessageSendingError);
        //     }
        // }
        // },
        // updateErrorMessageAsLoading(errorMessage: IMessageItem) {
        // let messages = this.messages.slice(0);
        // messages.forEach((message) => {
        //     if (message.isError && message.createdOn == errorMessage.createdOn) {
        //         message.isLoading = true;
        //     }
        // });
        // this.$emit("update:messages", messages);
        // this.handleJoinMeetingButtons();
        // },
        // markMessageError(createdDateTime: Date | string, messageErrorType: MessageErrorEnum) {
        // let messages = this.messages.slice(0);
        // messages.forEach((message) => {
        //     if (message.isLoading && message.isError && message.createdOn == createdDateTime) {
        //         message.isLoading = false;
        //         message.isError = true;
        //         message.errorMessage = messageErrorType;
        //     }
        // });
        // this.$emit("update:messages", messages);
        // this.handleJoinMeetingButtons();
        // },
        // updateSentMessage(messagesResult: ISendMessageResult, oldDateTime: Date | string, newDateTime: Date) {
        //     let messages = this.messages.slice(0);
        //     this.moveMessageToTop(oldDateTime);
        //     messages.forEach((message) => {
        //         if (message.isLoading && message.isError && message.createdOn == oldDateTime) {
        //             message.isLoading = false;
        //             message.isError = false;
        //             message.createdOn = newDateTime;
        //             message.id = messagesResult.id;
        //         }
        //     });
        //     // this.$emit("update:messages", messages);
        // },
        // moveMessageToTop(dateTime: Date | string) {
        //     let messages = this.messages.splice(0);
        //     let index = messages.findIndex((message) => message.createdOn == dateTime);
        //     messages.push(messages.splice(index, 1)[0]);
        //     // this.$emit("update:messages", messages);
        // },
    }
});
